// src/features/auth/hooks/useAuth.js
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login, register, forgotPassword, resetPassword, logout, clearError, clearMessage } from '../../../app/store/slices/authSlice';

export const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const { user, isLoading, error, isAuthenticated, message } = useSelector(
    (state) => state.auth
  );
  
  const handleLogin = async (credentials) => {
    const result = await dispatch(login(credentials));
    if (login.fulfilled.match(result)) {
      navigate('/dashboard');
      return true;
    }
    return false;
  };
  
  const handleRegister = async (userData) => {
    const result = await dispatch(register(userData));
    if (register.fulfilled.match(result)) {
      navigate('/login');
      return true;
    }
    return false;
  };
  
  const handleForgotPassword = async (email) => {
    const result = await dispatch(forgotPassword(email));
    if (forgotPassword.fulfilled.match(result)) {
      return true;
    }
    return false;
  };
  
  const handleResetPassword = async (data) => {
    const result = await dispatch(resetPassword(data));
    if (resetPassword.fulfilled.match(result)) {
      navigate('/login');
      return true;
    }
    return false;
  };
  
  const handleLogout = async () => {
    await dispatch(logout());
    navigate('/login');
  };
  
  const clearAuthError = () => {
    dispatch(clearError());
  };
  
  const clearAuthMessage = () => {
    dispatch(clearMessage());
  };
  
  return {
    user,
    isLoading,
    error,
    isAuthenticated,
    message,
    login: handleLogin,
    register: handleRegister,
    forgotPassword: handleForgotPassword,
    resetPassword: handleResetPassword,
    logout: handleLogout,
    clearError: clearAuthError,
    clearMessage: clearAuthMessage,
  };
};